import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate, useParams} from 'react-router-dom';
import '../../css/private/create-whatsapp-template.css';
import SideBar from './../components/SideBar';
import { format } from 'date-fns';
import axios from 'axios';

import Cookies from 'js-cookie';
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { Select, MenuItem, FormControl, InputBase, Radio, Checkbox, FormControlLabel } from "@mui/material";

const CreateWhatsappTemplate = () => {

  const ServerApiDomain = process.env.REACT_APP_SPRING_SERVER_API_DOMAIN;

   useEffect(() => {
      document.title = 'Create New WhatsApp Template | Aadow';

    }, []);

    
    const CookieMetaSystemUserToken = Cookies.get('meta_system_user_token');
    
    const { TemplateId } = useParams();
    const location = useLocation();
    const isNewTemplate = location.pathname.endsWith('/new');
    const [step, setStep] = useState(isNewTemplate ? 1 : 2);

    useEffect(() => {
        
    }, [isNewTemplate, step]);
   
  const CookietId = Cookies.get('current_Id');
  const CookieAccountId = Cookies.get('current_accountId');
  const [checked, setChecked] = useState(false);
  const [CodeDeliverySetupChecked, setCodeDeliverySetupChecked] = useState(true);
  const [AddSecurityRecommendation, setAddSecurityRecommendation] = useState(false);
  const [AddExpiryTimeOfTheCode, setAddExpiryTimeOfTheCode] = useState(false);
  const [CustomValidityTimePeriod, setCustomValidityTimePeriod] = useState(false);
  const [expiryTime, setExpiryTime] = useState();
  const CookieAccountName = Cookies.get('current_accountName');
  const CookieAccountEmail = Cookies.get('current_accountEmail');
  
  const [templateName, settemplateName] = useState("your_template_name");
  
  const [templateLanguage, settemplateLanguage] = useState("en_US");

  const [responseMessage, setResponseMessage] = useState("");
  
  const [TemplateStatus, setTemplateStatus] = useState("");
  
  const [FullPageloading, setFullPageloading] = useState(false);

  const handleCreateTemplate = async () => {
    setFullPageloading(true);
    const apiUrl = `${ServerApiDomain}/whatsapp-templates/517955028071761/create-template`;
    
    const requestBody = {
      templateName: templateName,
      category: selectedTab,
      username: CookieAccountId,
      name: templateName,
      language: templateLanguage,
      components: [
        {
          type: "BODY",
          text: "Thank you for your orders, {{1}}! Your confirmation number is {{2}}. If you have any questions, please use the buttons below to contact support. Thank you for being a customer!",
          
          example: {
            body_text: [["Pablo", "860198-230332"]],
          },
          
        },
      ],
    };

  console.log("Request Body:", JSON.stringify(requestBody, null, 2));

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      const data = await response.json();
      
      console.log(data.status);
      setFullPageloading(false);
      setStep(3);
    } catch (error) {
      getResponseMessage("success");
      setFullPageloading(false);
      console.error("Error:", error);
      console.log("Failed to create template.");
    }
  };
  

  
  const [getResponseMessageImage, setgetResponseMessageImage] = useState("../../iconss/other/sand-clock.png");
  const [getResponseMessageHeading, setgetResponseMessageHeading] = useState("Template created successfully!");
  const [getResponseMessageDescription, setgetResponseMessageDescription] = useState("Your template is currently under review. Once it gets approved, you will be able to use it.");
  
  const [selectedTab, setSelectedTab] = useState("Marketing");
  const [selectedSubcategory, setSelectedSubcategory] = useState("Custom");

  // Define categories and subcategories
  const categories = ["Marketing", "Utility"];
  const subcategories = {
    Marketing: [
      { name: "Custom", description: "Send promotions or announcements to increase awareness and engagement." }
    ],
    Utility: [
      { name: "Custom", description: "Send messages about an existing order or account." },
      { name: "Order Status", description: "Send messages to tell customers about the progress of their orders." },
    ],
    Authentication: [
      { name: "One-time passcode", description: "Send codes to verify a transaction or login." }
    ],
  };

  const previewContent = {
    Marketing: {
      Custom: {
        message: "https://static.xx.fbcdn.net/rsrc.php/v4/yN/r/v8ib9s0JOMo.png",
        goodFor: "Welcome messages, promotions, offers, coupons, newsletters, announcements",
        customizable: "Header, body, footer, button",
      },
      Catalogue: {
        message: "https://static.xx.fbcdn.net/rsrc.php/v4/y1/r/xJdfTT0gV68.gif",
        goodFor: "Product/service discovery, sales, offers, targeted marketing, personalised shopping",
        customizable: "Catalogue, body",
      },
      Flows: {
        message: "https://static.xx.fbcdn.net/rsrc.php/v4/yz/r/4H6zSr_9q2A.gif",
        goodFor: "Sign-ups, promotions, surveys, appointments",
        customizable: "Form, body, button",
      },
      "Order Details": {
        message: "https://static.xx.fbcdn.net/rsrc.php/v4/yl/r/9CaRl7XcB_Z.png",
        goodFor: "Basket abandonment",
        customizable: "Header, body, footer",
      },
    },
    Utility: {
      Custom: {
        message: "https://static.xx.fbcdn.net/rsrc.php/v4/yk/r/Czm3vxesN-O.png",
        goodFor: "Order confirmations, account update, receipts, appointment reminders, billing",
        customizable: "Header, body, footer, button",
      },
      Flows: {
        message: "https://static.xx.fbcdn.net/rsrc.php/v4/yZ/r/kQTcoVBAOiV.gif",
        goodFor: "Customer support, surveys",
        customizable: "Form, body, button",
      },
      "Order Status": {
        message: "https://static.xx.fbcdn.net/rsrc.php/v4/yI/r/yOb0ocTbOUq.png",
        goodFor: "Order confirmation, order status, delivery status",
        customizable: "Body, footer",
      },
      "Order Details": {
        message: "https://static.xx.fbcdn.net/rsrc.php/v4/yM/r/qIhNJs3JZwV.png",
        goodFor: "Payment/invoice reminders, billing information, product availability, basket abandonment",
        customizable: "Header, body, footer",
      },
    },
    Authentication: {
      "One-time passcode": {
        message: "https://static.xx.fbcdn.net/rsrc.php/v4/yL/r/vwkjuR20nRH.png",
        goodFor: "One-time password, account recovery code, account verification, integrity challenges",
        customizable: "Code delivery method",
      }
    },
  };
  


  const nextStep = () => {
    if(step === 1){
      if(selectedTab === 'Authentication'){
        setBody("{{1}} is your verification code.")
      }else{
        setBody("Hello there.....");
      }
    }
    setStep((prev) => Math.min(prev + 1, 3));
  };

  const prevStep = () => {
    if(step === 2){
      window.location.reload();
    }
    setStep((prev) => Math.max(prev - 1, 1));
  };

  const getResponseMessage = (status) => {
    switch (status) {
      case 'success':
        setgetResponseMessageHeading("Template Submitted Successfully");
        setgetResponseMessageDescription("Your template has been successfully submitted and is under review. You will be notified once it is approved.");
      case 'pending':
      setgetResponseMessageHeading("Template Submission Pending");
      setgetResponseMessageDescription("Your template is still under review. This process may take some time. Please check back later.");
      case 'rejected':
      setgetResponseMessageHeading("Template Submission Rejected");
      setgetResponseMessageDescription("Your template was rejected due to policy violations. Please review the feedback and make necessary changes before resubmitting.");
      default:
      setgetResponseMessageHeading("Template Submission Pending");
      setgetResponseMessageDescription("Your template is still under review. This process may take some time. Please check back later.");
    }
  };
  
  const handleInputNameChange = (e) => {
    let value = e.target.value.trim(); // Remove leading/trailing spaces
    if (value) {
      value = value.replace(/\s+/g, '_'); // Replace spaces with underscores
      settemplateName(value);
    }
  };
  
  const handleLanguageChange = (e) => {
    settemplateLanguage(e.target.value);
  };


  let tabIcon = 'bi-grid'; // Default icon

  if (selectedTab === 'Marketing') {
    tabIcon = 'bi-megaphone';
  } else if (selectedTab === 'Utility') {
    tabIcon = 'bi-bell';
  } else if (selectedTab === 'Authentication') {
    tabIcon = 'bi-shield-lock';
  }

  const [header, setHeader] = useState('');
  const [headerType, setHeaderType] = useState(''); // TEXT, IMAGE, VIDEO, DOCUMENT
  const [body, setBody] = useState('');
  const [footer, setFooter] = useState('');
  const [buttons, setButtons] = useState([]);
  const [validityPeriod, setValidityPeriod] = useState('30s');



  




  const handleSubmit = async () => {
    const payload = preparePayload();
    setFullPageloading(true);
     try {
         const response = await axios.post(
             `https://graph.facebook.com/v18.0/517955028071761/message_templates`,
             payload,
             {
                 headers: {
                     'Authorization': `Bearer ${CookieMetaSystemUserToken}`,
                     'Content-Type': 'application/json'
                 }
             }
         );

         console.log('Template Created Successfully:', response.data);
         setFullPageloading(false);

         if (response.data.status !== 'REJECTED') {
          const templateData = {
              username: CookieAccountId, // replace with the actual username
              templateId: response.data.id, // or the correct templateId from response
              templateName: templateName.toLowerCase().replace(/\s/g, '_'), // or the correct templateName from response
              language: templateLanguage, // if available from response
              category: selectedTab, // if available from response
              status: "PENDING" // this might be 'APPROVED' or 'PENDING'
          };

          // Insert this template data into your backend API
          try {
              const saveResponse = await fetch(
                  `${ServerApiDomain}/whatsapp-templates`, // Use the correct URL of your backend
                  {
                      method: 'POST',
                      headers: {
                          'Content-Type': 'application/json',
                      },
                      body: JSON.stringify(templateData),
                  }
              );

              if (!saveResponse.ok) {
                  throw new Error('Error saving template to the database');
              }

              console.log('Template saved successfully in the database');
          } catch (error) {
              console.error('Error saving template to the database:', error);
          }
        }
         
         if (response.data.status === 'REJECTED') {
          // Handle Rejected Case
          setgetResponseMessageImage('../../iconss/other/report.png');
          setgetResponseMessageHeading('Template Rejected!');
          setgetResponseMessageDescription(`Your template was rejected because its message content does not align with the selected category. Please review your template and ensure it complies with WhatsApp's category guidelines.`);
        } else {
            // Handle Approved or Pending Review Case
            setgetResponseMessageImage('../../iconss/other/sand-clock.png');
            setgetResponseMessageHeading('Template created successfully!');
            setgetResponseMessageDescription('Your template is currently under review. Once it gets approved, you will be able to use it.');
        }

         setStep(3);
     } catch (error) {
         console.error('Error creating template:', error.response?.data || error.message);
         console.log('Failed to create template. Check console for details.');
         console.log('Authorization Token:', CookieMetaSystemUserToken);
         console.log('🚀 Generated Payload:', JSON.stringify(payload, null, 2));
         console.error('Error creating template:', error.response?.data || error.message);
         console.log('Full Error Response:', error.response);
         setStep(3);
         setFullPageloading(false);
         setgetResponseMessageHeading('Template created successfully!');
         setgetResponseMessageDescription('Your template is currently under review. Once it gets approved, you will be able to use it.');
        
     }
  };



  const preparePayload = () => {
    const components = [];
    // Header Section
    // Header Section
    if (headerType === 'TEXT' && headerText) {
      components.push({
          type: 'HEADER',
          format: 'TEXT',
          text: headerText
      });
    } else if (headerType === 'IMAGE' && headerImageUrl) {
      components.push({
          type: 'HEADER',
          format: 'IMAGE',
          image_url: headerImageUrl
      });
    }
    // Body Section
    if (body) {
        components.push({
            type: 'BODY',
            text: body
        });
    }

    // Footer Section
    if (footer) {
        components.push({
            type: 'FOOTER',
            text: footer
        });
    }

    // Buttons Section
    if (buttons.length > 0) {
        const formattedButtons = buttons.map(btn => {
            if (btn.type === 'Marketing opt-out') {
                return { type: 'QUICK_REPLY', text: btn.text };
            } 
            else if (btn.type === 'Visit Website') {
                return { type: 'URL', text: btn.text, url: btn.link };
            } 
            else if (btn.type === 'Call Phone Number') {
                return { type: 'PHONE_NUMBER', text: btn.text, phone_number: btn.link };
            } 
            else if (btn.type === 'Custom Button') {
                return { type: 'QUICK_REPLY', text: btn.text };
            }
        });

        components.push({ type: 'BUTTONS', buttons: formattedButtons });
    }

    if (selectedTab === 'Authentication' && selectedSubcategory === 'One-time passcode' && expiryTime) {
      const codeSetup = {
          type: 'CODE_DELIVERY_SETUP',
          method: 'COPY_CODE',
          description: 'Customers copy and paste the code into your app.'
      };

      // **Add Expiry Time if Checkbox is Checked**
      if (AddExpiryTimeOfTheCode && expiryTime) {
          codeSetup.expiry_time = `${expiryTime} mins`; // Add expiry time to payload
      }

      components.push(codeSetup);
    }

    if (AddSecurityRecommendation) {
        components.push({
            type: 'SECURITY_RECOMMENDATION',
            text: 'For your security, do not share this code.'
        });
    }

    if (CustomValidityTimePeriod) {
        components.push({
            type: 'VALIDITY_PERIOD',
            time: validityPeriod
        });
    }

    // Final Payload
    const payload = {
        name: templateName.toLowerCase().replace(/\s/g, '_'),
        category: selectedTab,
        language: templateLanguage,
        components
    };

    console.log('🚀 Generated Payload:', JSON.stringify(payload, null, 2));

    return payload;
  };


    const [showDropdown, setShowDropdown] = useState(false);

    // Add Button - Show Dropdown
    const handleAddButtonClick = () => {
        setShowDropdown(!showDropdown);
    };

    // Add Button with Specific Type
    const handleAddButton = (type) => {
      let newButton;
      if (type === 'Marketing opt-out') {
        newButton = {
          type,
          text: 'Unsubscribe',
          link: ''
        };
      }else if (type === 'Visit Website') {
        newButton = {
          type,
          text: 'Visit Website',
          link: ''
        };
      }else if (type === 'Call Phone Number') {
        newButton = {
          type,
          text: 'Call Us',
          link: ''
        };
      }else if (type === 'Copy Code') {
        newButton = {
          type,
          text: 'Copy Code',
          link: ''
        };
      } else {
        newButton = {
          type,
          text: 'Custom Message',
          link: ''
        };
      }
      setButtons([...buttons, newButton]);
      setShowDropdown(false); // Close dropdown after selection
    };
    

    // Handle Input Changes
    const handleInputChange = (index, key, value) => {
        const updatedButtons = [...buttons];
        updatedButtons[index][key] = value;
        setButtons(updatedButtons);
    };

    // Delete Button
    const handleDeleteButton = (index) => {
        const updatedButtons = [...buttons];
        updatedButtons.splice(index, 1);
        setButtons(updatedButtons);
    };
    const availableButtonTypes = [
      'Marketing opt-out',
      'Visit Website',
      'Call Phone Number',
      'Custom Button'
  ];

  const [headerText, setHeaderText] = useState('');
  const [headerImage, setHeaderImage] = useState('');
  const [headerImageFile, setHeaderImageFile] = useState(null);
  const [headerImageUrl, setHeaderImageUrl] = useState(''); // URL from your server

  

  useEffect(() => {

    if(isNewTemplate !== true){
      fetchTemplateData();
    }

  }, []);


  const fetchTemplateData = async () => {
    setFullPageloading(true);
    try {
        const response = await fetch(
            `https://graph.facebook.com/v21.0/517955028071761/message_templates?name=${TemplateId}`,
            {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${CookieMetaSystemUserToken}`
                }
            }
        );


        const data = await response.json();
        console.log('Fetched Template Data:', JSON.stringify(data, null, 2));

        const template = data?.data?.[0] || {};

        settemplateName(template.name);
        settemplateLanguage(template.language);
        const bodyText = template.components?.find(comp => comp.type === 'BODY')?.text || '';
        setBody(bodyText);
        
        const headerTextFromApi = template.components?.find(
          comp => comp.type === 'HEADER' && comp.format === 'TEXT'
        )?.text || '';

        setHeaderText(headerTextFromApi);
        
        setHeaderText(headerTextFromApi);

        
        const footerTextFromApi = template.components?.find(comp => comp.type === 'FOOTER')?.text || '';
        setFooter(footerTextFromApi);

        const headerComponent = template.components?.find(comp => comp.type === 'HEADER');

        if (headerComponent) {
            if (headerComponent.format === 'TEXT') {
                setHeaderType('TEXT');
                setHeaderText(headerComponent.text || '');
                setHeaderImageUrl(null); // Reset Image if switching
            } else if (headerComponent.format === 'IMAGE') {
                setHeaderType('IMAGE');
                const imageUrlFromApi = headerComponent.example?.header_handle?.[0] || '';
                setHeaderImageUrl(imageUrlFromApi);
                setHeaderText(''); // Reset Text if switching
            } else {
                setHeaderType('');
                setHeaderText('');
                setHeaderImageUrl(null);
            }
        }


        const buttonComponent = template.components?.find(comp => comp.type === 'BUTTONS');
        if (buttonComponent && buttonComponent.buttons) {
            const preSetButtons = buttonComponent.buttons.map((btn) => {
                let type = '';
                let link = '';

                // Map API response types to your UI structure
                if (btn.type === 'URL') {
                    type = 'Visit Website';
                    link = btn.url;
                } else if (btn.type === 'PHONE_NUMBER') {
                    type = 'Call Phone Number';
                    link = btn.phone_number;
                } else if (btn.type === 'QUICK_REPLY') {
                    type = 'Custom Button';
                }

                return {
                    type,
                    text: btn.text,
                    link
                };
            });

            setButtons(preSetButtons);
        }

        setFullPageloading(false);

        setTemplateStatus(template.status);
        
        
        const imageUrlFromApi = data?.data?.[0]?.components?.find(
            (component) => component.type === 'HEADER' && component.format === 'IMAGE'
        )?.example?.header_handle[0];
        
    } catch (error) {
        console.error('Error fetching template data:', error);
    }
  };




  const [variable, setVariable] = useState('');

  return (
    <SideBar>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={FullPageloading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <div className="create-whatsapp-template-content ">
        <>

            <div className="create-whatsapp-template-body ">
                        <div className="breadcrumb-area"> 
                        <nav aria-label="breadcrumb">
                          <ol className="breadcrumb">
                          <li className="breadcrumb-item"><Link to="/dashboard">Dashboard</Link></li>
                          <li className="breadcrumb-item"><Link to="/whatsapp-templates">WhatsApp Templates</Link></li>
                          <li className="breadcrumb-item active" aria-current="page">Create Template</li>
                          </ol>
                        </nav>
                        </div>
                        {step !== 3 && (
                        <div className='step-area'>
                          <div className='row d-flex align-items-center'>
                            <div className='col-2'>
                              <h4 className={`step-heading d-flex align-items-center ${step >= 1 ? '' : 'text-secondary'}`}>
                                <span>
                                  <i className={`bi ${step > 1 ? 'bi-check-circle-fill text-success' : step === 1 ? 'bi-circle-half' : 'bi-circle'}`}></i> 
                                  Set up template
                                </span>
                              </h4>
                            </div>
                            <div className='col-1'></div>
                            <div className='col-2'>
                              <h4 className={`step-heading d-flex align-items-center ${step >= 2 ? '' : 'text-secondary'}`}>
                                <span>
                                  <i className={`bi ${step > 2 ? 'bi-check-circle-fill text-success' : step === 2 ? 'bi-circle-half' : 'bi-circle'}`}></i> 
                                  Edit template
                                </span>
                              </h4>
                            </div>
                            <div className='col-1'></div>
                            <div className='col-2'>
                              <h4 className={`step-heading d-flex align-items-center ${step === 3 ? '' : 'text-secondary'}`}>
                                <span>
                                  <i className={`bi ${step === 3 ? 'bi-check-circle-fill text-success' : 'bi-circle'}`}></i> 
                                  Submit for Review
                                </span>
                              </h4>
                            </div>
                          </div>
                        </div>
                        )}


                        {step === 1 && (
                        <div className="main-content-area">
                          <div className="row">
                            {/* Left Section */}
                            <div className="col">
                              <div className="editor-area">
                                {/* Header Area */}
                                <div className="header-area">
                                  <h2 className="heading">Set up your template</h2>
                                  <h6 className="subheading">
                                    Choose the category that best describes your message template. Then, select the type of message that
                                    you want to send.
                                  </h6>

                                  {/* Category Tabs */}
                                  <div className="row p-2">
                                    {categories.map((category, index) => (
                                      <div key={index} className="col m-0 p-0">
                                        <div
                                          className={`category-tab d-flex align-items-center justify-content-center ${
                                            selectedTab === category ? "active-tab" : ""
                                          }`}
                                          onClick={() => {
                                            setSelectedTab(category);
                                            setSelectedSubcategory(subcategories[category][0].name);
                                          }}
                                          style={{
                                            borderRadius: index === 0 ? "5px 0 0 5px" : index === categories.length - 1 ? "0 5px 5px 0" : "",
                                            cursor: "pointer",
                                          }}
                                        >
                                          <b className={`bi ${category === "Marketing" ? "bi-megaphone" : category === "Utility" ? "bi-bell" : "bi-shield-lock"}`}></b>{" "}
                                          {category}
                                        </div>

                                      </div>
                                    ))}
                                  </div>

                                  {/* Subcategories - Radio Selector */}
                                  <div className="mt-3">
                                    {subcategories[selectedTab].map((sub, index) => (
                                      <div
                                        key={index}
                                        className={`row align-items-center mt-3 subcategory-area ${
                                          selectedSubcategory === sub.name ? "active-subcategory-area" : ""
                                        }`}
                                        onClick={() => setSelectedSubcategory(sub.name)}
                                        style={{ cursor: "pointer" }}
                                      >
                                        <div className="col-1 me-0 pe-0 text-left">
                                          <b className={`bi ${selectedSubcategory === sub.name ? "bi-record-circle text-white" : "bi-circle"}`}></b>
                                        </div>
                                        <div className="col-11 ms-0 ps-0">
                                          <h2 className="heading">{sub.name}</h2>
                                          <h2 className={`subheading ${selectedSubcategory === sub.name ? "text-white" : ""}`}>{sub.description}</h2>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Right Section - Template Preview */}
                            <div className="col-3 ps-5">
                            <div className="preview-area">
                              <div className="header-area mb-0">
                                <h2 className="heading">Template Preview</h2>
                              </div>
                              <div className='p-2 bg-white'>
                                <center>
                                <img style={{
                                            width: "85%",
                                            borderRadius: "10px",
                                            height: "auto",
                                            objectFit: "contain"
                                          }} src={previewContent[selectedTab]?.[selectedSubcategory]?.message} />
                                          </center>
                              </div>
                              <div className="header-area footer-area mb-0">
                                <h2 className="heading">This template is good for</h2>
                                <h2 className="subheading">
                                  {previewContent[selectedTab]?.[selectedSubcategory]?.goodFor || "No description available"}
                                </h2>
                                <h2 className="heading">Template areas that you can customise</h2>
                                <h2 className="subheading">
                                  {previewContent[selectedTab]?.[selectedSubcategory]?.customizable || "No details available"}
                                </h2>
                              </div>
                            </div>
                          </div>

                          </div>

                          {/* Footer Buttons */}
                          <br />
                          {step < 3 && (
                            <footer className='header-area pt-3 pb-3'>
                              <div className='row'>
                                <div className='col-12 text-end'>
                                  {step > 1 && <button type='button' className='button-secondary-outline' onClick={prevStep}>Previous</button>}
                                  <button type='button' className='button-primary' onClick={nextStep}>Next</button>
                                </div>
                              </div>
                            </footer>
                          )}
                        </div>
                        )}

                        {step === 2 && (
                        <div className='main-content-area'>
                        <div className='row'>
                          <div className='col-8'>
                          <div className='editor-area'>
                          <div className='header-area'>
                                  <div className='row align-items-center'>
                                      <div className='col-1'>
                                          <i className={`bi ${tabIcon}`}></i>
                                      </div>
                                      <div className='col-9'>
                                          <h2 className='heading'>{templateName} <span>•</span> {templateLanguage}</h2>
                                          <h6 className='subheading'>{selectedTab} <span>•</span> {selectedSubcategory}</h6>
                                      </div>
                                      <div className='col-2 text-end'>
                                      {!isNewTemplate && (
                                        <span className={`template-status ${TemplateStatus}`}>{TemplateStatus}</span>
                                      )}
                                      </div>
                                  </div>
                              </div>

                              {/* Template Name & Language */}
                              {(
                                  (selectedTab === 'Marketing' && selectedSubcategory === 'Custom') ||
                                  (selectedTab === 'Utility' && selectedSubcategory === 'Custom') ||
                                  (selectedTab === 'Utility' && selectedSubcategory === 'Order Status') ||
                                  (selectedTab === 'Authentication' && selectedSubcategory === 'One-time passcode')
                              ) && (
                                  <div className='header-area'>
                                      <h2 className='heading'>Template name and language</h2>
                                      <div className='row align-items-center'>
                                          <div className='col-8'>
                                              <h6 className='subheading'>Name your Template</h6>
                                              <input 
                                                  disabled={!isNewTemplate}
                                                  type="text" 
                                                  className="form-input"
                                                  value={templateName}
                                                  placeholder="Enter a template name" 
                                                  onChange={(e) => settemplateName(e.target.value)} 
                                              />
                                          </div>
                                          <div className='col-4'>
                                              <h6 className='subheading'>Select language</h6>
                                              <select 
                                                  className="form-input"
disabled={!isNewTemplate} 
                                                  value={templateLanguage} 
                                                  onChange={(e) => settemplateLanguage(e.target.value)}
                                              >
                                                  <option value="en_US">English</option>
                                              </select>
                                          </div>
                                      </div>
                                  </div>
                              )}

                              {/* Content Section */}
                              {(
                                  (selectedTab === 'Marketing' && selectedSubcategory === 'Custom') ||
                                  (selectedTab === 'Utility' && selectedSubcategory === 'Custom') ||
                                  (selectedTab === 'Utility' && selectedSubcategory === 'Order Status')
                              ) && (
                                  <div className='header-area'>
                                      <h2 className='heading'>Content</h2>
                                      <h6 className='subheading'>Fill in the variable, header, body, and footer sections.</h6>
                                     

                                      <select
                                        value={{variable}}
                                        onChange={(e) => setVariable(e.target.value)}
                                        className="form-input d-none"
                                        disabled={!isNewTemplate}>
                                        <option value="Name">Name</option>
                                        <option value="Number">Number</option>
                                      </select>

                                      
                                      {(
                                      (selectedTab === 'Marketing' && selectedSubcategory === 'Custom') ||
                                      (selectedTab === 'Utility' && selectedSubcategory === 'Custom')
                                      ) && (
                                        <>
                                            <div className='row align-items-center'>
                                                <div className='col-12'>
                                                    <h6 className='subheading text-dark mt-2'>Select Header Type</h6>
                                                    <select 
                                                        className="form-input"
                                                        disabled={!isNewTemplate} 
                                                        value={headerType} 
                                                        onChange={(e) => setHeaderType(e.target.value)}
                                                    >
                                                        <option value="">None</option>
                                                        <option value="TEXT">Text</option>
                                                        <option value="IMAGE">Image</option>
                                                    </select>
                                                </div>
                                            </div>

                                            {/* Conditional Inputs Based on Header Type */}
                                            {headerType === 'TEXT' && (
                                                <input 
                                                    type="text" 
                                                    className="form-input"
                                                    disabled={!isNewTemplate}
                                                    placeholder='Enter Header Text'
                                                    value={headerText}
                                                    onChange={(e) => setHeaderText(e.target.value)}
                                                />
                                            )}

                                            {headerType === 'IMAGE' && (
                                              <>
                                                {/* Show image placeholder or uploaded image */}
                                                <div className="image-upload-container pb-3">
                                                  <input
                                                    type="file"
                                                    accept="image/*"
                                                    id="file-input"
                                                    onChange={async (event) => {
                                                      const file = event.target.files[0];
                                                      if (file) {
                                                        setFullPageloading(true);
                                                        const formData = new FormData();
                                                        formData.append('file', file);
                                                    
                                                        try {
                                                          const response = await axios.post(
                                                            `${ServerApiDomain}/api/files/upload`,
                                                            formData,
                                                            {
                                                              headers: {
                                                                'Content-Type': 'multipart/form-data',
                                                              },
                                                            }
                                                          );
                                                    
                                                          const uploadedFileName = response.data.fileName;
                                                          const imageUrl = `https://www.aadow.com/uploads/${uploadedFileName}`;
                                                    
                                                          setHeaderImageFile(file);         // Optionally store the file
                                                          setHeaderImageUrl(imageUrl);      // Display the uploaded image
                                                        } catch (error) {
                                                          console.error('Upload failed:', error);
                                                        } finally {
                                                          setFullPageloading(false);
                                                        }
                                                      }
                                                    }}                                                    
                                                    style={{ display: 'none' }} // Hide the default file input button
                                                  />
                                                  
                                                  {/* Show the placeholder or the uploaded image */}
                                                  {!headerImageUrl ? (
                                                    <label htmlFor="file-input" className="image-placeholder">
                                                      <img
                                                        src=  "https://www.aadow.com/images/upload-media.jpeg" // Default placeholder image
                                                        alt="Upload"
                                                        className="placeholder-img"
                                                      />
                                                    </label>
                                                  ) : (
                                                    <label className="image-placeholder">
                                                      <img
                                                        src={headerImageUrl}
                                                        alt="Uploaded Image"
                                                        className="placeholder-img"
                                                      />
                                                      
                                                          <button
                                                          className="remove-image-btn"
                                                          onClick={() => {
                                                            setHeaderImageUrl(null); // Clear the image URL
                                                            setHeaderImageFile(null); // Optional, if you want to clear the image file as well
                                                          }}
                                                        > 
                                                          <span className="remove-icon">X</span>
                                                          </button>
                                                        
                                                    </label>
                                                  )}
                                                </div>
                                              </>
                                            )}

                                      </>
                                      )}
                                        
                                      <h6 className='subheading text-dark mt-2'>Message<b className='text-danger'>*</b></h6>
                                      <textarea 
                                          className="form-input"
                                          disabled={!isNewTemplate} 
                                          placeholder='Enter text in English'
                                          value={body}
                                          onChange={(e) => setBody(e.target.value)}
                                      />
                                      <h6 className='subheading text-dark mt-2'>Footer</h6>
                                      <input 
                                          type="text" 
                                          className="form-input"
                                          disabled={!isNewTemplate}
                                          value={footer}
                                          placeholder='Footer'
                                          onChange={(e) => setFooter(e.target.value)}
                                      />
                                  </div>
                              )}

                              {/* Code Delivery Setup */}
                              {selectedTab === 'Authentication' && selectedSubcategory === 'One-time passcode' && (
                                  <div className='header-area'>
                                      <h2 className='heading'>Code delivery setup                                      </h2>
                                      <h6 className='subheading'>Choose how customers send the code from WhatsApp to your app. Edits to this section won't require review or count towards edit limits.</h6>
                                      <div className='row align-items-center'>
                                          <div className='col'>
                                          <h2 className='heading mb-0 pb-0'>Copy code</h2>
                                          <h6 className='subheading pt-0 mt-0'>Basic authentication with quick setup. Your customers copy and paste the code into your app.                                          </h6>
                                          </div>
                                          <div className='col-1'>
                                            <FormControlLabel
                                                                                    control={
                                                                                      <Radio
                                                                                      disabled={!isNewTemplate}
                                                                                        checked={CodeDeliverySetupChecked}
                                                                                        onChange={(e) => setCodeDeliverySetupChecked(e.target.checked)}
                                                                                        color="primary"
                                                                                      />
                                                                                    }
                                                                                    className="custom-label" // Apply the custom CSS class
                                                                                  />
                                          </div>
                                      </div>
                                      
                                  </div>
                              )}

                              {selectedTab === 'Authentication' && selectedSubcategory === 'One-time passcode' && (
                                  <div className='header-area'>
                                      <h2 className='heading'>Content</h2>
                                      <h6 className='subheading'>Content for authentication message templates can't be edited. You can add additional content from the options below.                                      </h6>
                                      <div className='row align-items-center mb-0 pb-0'>
                                          <div className='col'>
                                          <h2 className='heading mb-0 pb-0'>Add security recommendation
                                          </h2>
                                          </div>
                                          <div className='col-1'>
                                            <FormControlLabel
                                                                                    control={
                                                                                      <Checkbox
                                                                                      disabled={!isNewTemplate}
                                                                                        checked={AddSecurityRecommendation}
                                                                                        onChange={(e) => setAddSecurityRecommendation(e.target.checked)}
                                                                                        color="primary"
                                                                                      />
                                                                                    }
                                                                                    className="custom-label" // Apply the custom CSS class
                                                                                  />
                                          </div>
                                      </div>
                                      <div className='row align-items-center mt-0 pt-0'>
                                        <div className='col'>
                                          <h2 className='heading mb-0 pb-0'>Add expiry time for the code</h2>
                                        </div>
                                        <div className='col-1'>
                                          <FormControlLabel
                                            control={
                                              <Checkbox
                                              disabled={!isNewTemplate}
                                                checked={AddExpiryTimeOfTheCode}
                                                onChange={(e) => setAddExpiryTimeOfTheCode(e.target.checked)}
                                                color="primary"
                                              />
                                            }
                                            className="custom-label"
                                          />
                                        </div>
                                      </div>

                                      {/* Expiry Time Dropdown - Show Only When Checkbox is Checked */}
                                      {AddExpiryTimeOfTheCode && (
                                        <div className='row align-items-center mt-2'>
                                          <div className='col'>
                                            <select
                                              className='form-select'
                                              value={expiryTime}
                                              onChange={(e) => setExpiryTime(e.target.value)}
                                            >
                                              <option value="2">Expires in 2 mins</option>
                                              <option value="5">Expires in 5 mins</option>
                                              <option value="10">Expires in 10 mins</option>
                                              <option value="15">Expires in 15 mins</option>
                                              <option value="20">Expires in 20 mins</option>
                                              <option value="30">Expires in 30 mins</option>
                                            </select>
                                          </div>
                                        </div>
                                      )}
                                      
                                  </div>
                              )}

                              {/* Buttons Section */}
                              {(
                                  (selectedTab === 'Marketing' && selectedSubcategory === 'Custom') ||
                                  (selectedTab === 'Utility' && selectedSubcategory === 'Custom')
                              ) && (
                                  <div className='header-area'>
                                      <h2 className='heading'>Buttons</h2>
                                      <h6 className='subheading'>Add button options for customer actions.</h6>
                                      {isNewTemplate && (
                                      <button 
                                          type="button" 
                                          className='add-btn-primary' 
                                          onClick={handleAddButtonClick}
                                      >
                                         + Add Button <b class="bi bi-caret-down-fill ps-2 fw-bold"></b>
                                      </button>
                                      )}

                                      {/* Dropdown Menu */}
                                      {showDropdown && (
                                          <div className='btn-dropdown-menu'>
                                              {availableButtonTypes.map((type) => (
                                                  <div 
                                                      key={type} 
                                                      className={`btn-dropdown-item ${buttons.some(btn => btn.type === type) ? 'disabled' : ''}`}
                                                      onClick={() => handleAddButton(type)}
                                                  >
                                                      {type}
                                                  </div>
                                              ))}
                                          </div>
                                      )}

                                      {/* Button Input Fields */}
                                      {buttons.map((btn, index) => (
                                          <div key={index} className='btn-row mt-2 pt-2'>
                                              <select
                                                  className='btn-input'
                                                  value={btn.type}
                                                  onChange={(e) => handleInputChange(index, 'type', e.target.value)}
                                                  disabled
                                              >
                                                  <option value="Marketing opt-out">Marketing opt-out</option>
                                                  <option value="Visit Website">Visit Website</option>
                                                  <option value="Call Phone Number">Call Phone Number</option>
                                                  <option value="Custom Button">Custom Button</option>
                                              </select>

                                              
                                              {(
                                                  !isNewTemplate ? (
                                                      
                                                      <input 
                                                  type="text" 
                                                  className="btn-input"
                                                  placeholder='Button Text'
                                                  value={btn.text}
                                                          disabled="disabled"
                                              />

                                                  ) : (
                                                    <input 
                                                    type="text" 
                                                    className="btn-input"
                                                    placeholder='Button Text'
                                                    value={btn.text}
                                                    onChange={(e) => handleInputChange(index, 'text', e.target.value)}
                                                />
  
                                                  )
                                              )}


                                              {(btn.type === 'Visit Website' || btn.type === 'Call Phone Number') && (
                                                  !isNewTemplate ? (
                                                      <input 
                                                          type="text" 
                                                          className="btn-input"
                                                          placeholder={btn.type === 'Visit Website' ? 'Website URL' : 'Phone Number'}
                                                          value={btn.link}
                                                          disabled="disabled"
                                                      />
                                                  ) : (
                                                      <input 
                                                          type="text" 
                                                          className="btn-input"
                                                          placeholder="Website Link/Phone Number" // Change this as needed
                                                          value={btn.link}
                                                          onChange={(e) => handleInputChange(index, 'link', e.target.value)}
                                                      />
                                                  )
                                              )}
                                            
                                              
                                              
                                              {(
                                                  !isNewTemplate ? (
                                                      
                                                    <button 
                                                    type="button" 
                                                    className='btn-danger' 
                                                    disabled="disabled"
                                                >
                                                    Delete
                                                </button>

                                                  ) : (
                                                    <button 
                                                  type="button" 
                                                  className='btn-danger' 
                                                  onClick={() => handleDeleteButton(index)}
                                              >
                                                  Delete
                                              </button>
  
                                                  )
                                              )}



                                          </div>
                                      ))}
                                  </div>
                              )}

                              {/* Message Validity Period */}
                              {(
                                  (selectedTab === 'Marketing' && selectedSubcategory === 'Custom') ||
                                  (selectedTab === 'Utility' && selectedSubcategory === 'Custom') ||
                                  (selectedTab === 'Utility' && selectedSubcategory === 'Order Status') ||
                                  (selectedTab === 'Authentication' && selectedSubcategory === 'One-time passcode')
                              ) && (
                                  <div className='header-area'>
                                      <h2 className='heading'>Message Validity Period</h2>
                                      <h6 className='subheading'>You can set a custom validity period that your marketing message must be delivered by before it expires. If a message is not delivered within this time frame, you will not be charged and your customer will not see the message.
                                      </h6>
                                      <div className='row align-items-center'>
                                          <div className='col'>
                                          <h2 className='heading mb-0 pb-0'>Set custom validity period for your message</h2>
                                          <h6 className='subheading pt-0 mt-0'>If you don't set a custom validity period, the standard 10 minutes WhatsApp message validity period will be applied.</h6>
                                          </div>
                                          {isNewTemplate && (
                                          <div className='col-1'>
                                            <FormControlLabel
                                                                                    control={
                                                                                      <Checkbox
                                                                                      disabled={!isNewTemplate}
                                                                                        checked={CustomValidityTimePeriod}
                                                                                        onChange={(e) => setCustomValidityTimePeriod(e.target.checked)}
                                                                                        color="primary"
                                                                                      />
                                                                                    }
                                                                                    className="custom-label" // Apply the custom CSS class
                                                                                  />
                                          </div>
                                          )}
                                      </div>
                                      {CustomValidityTimePeriod && (
                                        <div className='row align-items-center mt-2'>
                                          <div className='col-4'>
                                            <select
                                              className='form-select'
                                              value={validityPeriod}
                                              onChange={(e) => setValidityPeriod(e.target.value)}
                                            >
                                              <option value='30s'>30 seconds</option>
                                              <option value='1m'>1 minute</option>
                                              <option value='2m'>2 minutes</option>
                                              <option value='3m'>3 minutes</option>
                                              <option value='5m'>5 minutes</option>
                                              <option value='10m'>10 minutes</option>
                                              <option value='15m'>15 minutes</option>
                                              <option value='30m'>30 minutes</option>
                                              <option value='1hrs'>1 hours</option>
                                              <option value='3hrs'>3 hours</option>
                                              <option value='6hrs'>6 hours</option>
                                              <option value='12hrs'>12 hours</option>
                                            </select>
                                          </div>
                                        </div>
                                      )}
                                  </div>
                              )}
                          </div>
                          </div>
                          <div className='col-4 ps-5'>
                            <div className='preview-area'>
                              <div className='header-area mb-0'>
                                <h2 className='heading'>Template Preview</h2>
                              </div>
                              <div style={{ borderRadius: "0 0 10px 10px", }} class="chat-box mt-0">
                              <div className="chat-bubble text-start received">
                                {/* Render HEADER */}
                                {preparePayload().components.find(comp => comp.type === "HEADER")?.format === "TEXT" && (
                                  <p><b>{preparePayload().components.find(comp => comp.type === "HEADER")?.text}</b></p>
                                )}

                                {preparePayload().components.find(comp => comp.type === "HEADER")?.format === "IMAGE" && (
                                  <img 
                                    src={preparePayload().components.find(comp => comp.type === "HEADER")?.image_url} 
                                    alt="Header Image" 
                                    className="header-image"
                                  />
                                )}

                                {/* Render BODY */}
                                {preparePayload().components.find(comp => comp.type === "BODY")?.text}

                                {/* Render FOOTER */}
                                <footer>{preparePayload().components.find(comp => comp.type === "FOOTER")?.text}</footer>

                                {/* Render Timestamp */}
                                <div className="timestamp">10:32 AM</div>

                                {/* Render Buttons */}
                                {preparePayload().components.find(comp => comp.type === "BUTTONS") && (
                                  <div className="button-container">
                                    {preparePayload().components.find(comp => comp.type === "BUTTONS")?.buttons.map((button, index) => (
                                      <div key={index} className="chat-button-wrapper">
                                        <button 
                                          className={`chat-button ${button.type.toLowerCase()}`} 
                                        >
                                          {button.type === "URL" && <i className="bi bi-box-arrow-up-right me-2"></i>}
                                          {button.type === "PHONE_NUMBER" && <i className="bi bi-telephone me-2"></i>}
                                          {button.type === "QUICK_REPLY" && <i className="bi bi-reply me-2"></i>}
                                          {button.text}
                                        </button>
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>

                              </div>
                            </div>
                          </div>
                        </div>
                        {step < 3 && isNewTemplate && (
                            <footer className='header-area pt-3 pb-3'>
                                <div className='row'>
                                    <div className='col-12 text-end'>
                                        {step > 1 && (
                                            <button 
                                                type='button' 
                                                className='button-secondary-outline' 
                                                onClick={prevStep}
                                            >
                                                Previous
                                            </button>
                                        )}
                                        <button 
                                            type='button' 
                                            className='button-primary' 
                                            onClick={handleSubmit}
                                        >
                                            Submit for Review
                                        </button>
                                    </div>
                                </div>
                            </footer>
                        )}
                        </div>
                        )}

                        {step === 3 && (
                                    <div className='main-content-area'>
                                      <div className="col-12">
                                        <div id="step_three" className="right-content success-content">
                                          <img src={getResponseMessageImage} className="success-icon" alt="Success" />
                                          <h2 className="secondary-heading-modal text-center">{getResponseMessageHeading}</h2>
                                          <h2 className="secondary-description-modal text-center">{getResponseMessageDescription}</h2>
                                          <center><Link to="/whatsapp-templates" className="primary-button text-decoration-none float-center mt-3 d-inline-block" >Go to Templates</Link></center>
                                        </div>
                                      </div>
                                    </div>
                        )}
                        
            </div>
        </>
      </div>
    </SideBar>
  );
};

export default CreateWhatsappTemplate;
